// 9fbef606107a605d69c0edbcd8029e5d
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import logger from '@tcp/core/src/utils/loggerInstance';
import { isGymboree, isSNJ } from '@tcp/core/src/utils';

const specialOffersTcp = require('@tcp/core/src/assets/special-offers-tcp.png');
const specialOffersGym = require('@tcp/core/src/assets/special-offers-gym.png');
const specialOffersSnj = require('@tcp/core/src/assets/special-offers-snj.png');

export const getPromotionsIcon = () => {
  if (isGymboree()) return specialOffersGym;
  if (isSNJ()) return specialOffersSnj;
  return specialOffersTcp;
};

export function getEarliestPromoStartDateEndDate(promo) {
  if (Array.isArray(promo) && promo.length) {
    const sortedPromos = promo?.sort((a, b) => a?.endTime - b?.endTime);
    const earliestPromoExpiry = new Date(sortedPromos[0]?.endTime).getTime();
    const earliestPromoStartTime = new Date(sortedPromos[0]?.startTime).getTime();
    return { earliestPromoStartTime, earliestPromoExpiry };
  }
  return {};
}

export function parseAppliedCoupons(res) {
  try {
    if (!has(res, 'c_couponMap')) return [];
    const couponMap = JSON.parse(res.c_couponMap);
    // check for non-empty object.
    if (isEmpty(couponMap)) return [];
    // extract coupons from cart response.
    return Object.values(couponMap).map((value) => {
      if (typeof value === 'string' && value.includes('|')) {
        const [couponCode, couponBody, startDate, endDate, status] = value?.split('|');
        return { couponCode, couponBody, startDate, endDate, status };
      }
      return { [value]: value };
    });
  } catch (error) {
    logger.error('Error: Error in parseAppliedCoupons', {
      error,
      extraData: {
        component: 'parseAppliedCoupons Saga - AddedToBag.saga.js',
      },
    });
    return null;
  }
}

/**
 * Check if a coupon is applied.
 * @param {string} couponToApply Coupon code to apply.
 * @param {Array} appliedCoupons Array of already applied coupons.
 */
export function checkIfCouponApplied(couponToApply, appliedCoupons) {
  if (Array.isArray(appliedCoupons) && appliedCoupons.length) {
    return !appliedCoupons.some((coupon) => {
      if (typeof coupon === 'object') {
        // Type 1: Check if couponCode matches couponToApply
        if (has(coupon, 'couponCode') && coupon.couponCode === couponToApply) {
          return true;
        }
        // Type 2: Check if the coupon object has a property named couponToApply
        if (has(coupon, couponToApply)) {
          return true;
        }
      }
      return false;
    });
  }
  return true;
}

/**
 * Check if a coupon is removed.
 * @param {string} couponToRemove Coupon code to remove.
 * @param {Array} appliedCoupons Array of already applied coupons.
 */
export function checkIfCouponRemoved(couponToRemove, appliedCoupons) {
  if (Array.isArray(appliedCoupons) && appliedCoupons.length) {
    return appliedCoupons.some((coupon) => {
      if (typeof coupon === 'object') {
        // Type 1: Check if couponCode matches couponToRemove
        if (has(coupon, 'couponCode') && coupon.couponCode === couponToRemove) {
          return true;
        }
        // Type 2: Check if the coupon object has a property named couponToRemove
        if (has(coupon, couponToRemove)) {
          return true;
        }
      }
      return false;
    });
  }
  return false; // Return false as no coupons are applied
}

/**
 * Handle errors by logging them.
 * @param {*} error Error object.
 */
export function handleError({ error, payload, methodName = '', fileName = '' }) {
  logger.error(`Error: Error in ${methodName}`, {
    error,
    extraData: {
      component: `${methodName} Saga - ${fileName}`,
      payload,
    },
  });
}

export const filteredPromotions = (promotions) =>
  Object.entries(promotions).reduce((acc, [, { offerType, discountValue }]) => {
    if (offerType && discountValue) {
      acc[`${offerType}_PROMO_DISCOUNT`] = discountValue;
    }
    return acc;
  }, {});

export default getPromotionsIcon;
